<template>
  <div id="main">
    <div v-if="isSuccess">
      <img src="images/car_wash/true.png" alt="">
      <p>恭喜您领券成功</p>
    </div>
  </div>
</template>

<script>
  import {getCarWashCoupon} from '@/apis/car_wash'

  export default {
    name: "index",
    data() {
      return {
        order_num: '', // 订单号
        isSuccess:true, // 领券是否成功
      }
    },
    methods:{

    },
    mounted() {
      this.order_num = this.$route.query.order_num

      // this.$dialog.confirm({
      //   title: '提示',
      //   message: '是否领取洗车券'
      // }).then(() => {
      //   getCarWashCoupon(this.order_num).then(res => {
      //     setTimeout(() => {
      //       let data = {jump: 'index'}
      //       jump.postMessage(JSON.stringify(data));
      //     }, 1000)
      //   })
      // }).catch(() => {
      //   setTimeout(() => {
      //     let data = {jump: 'index'}
      //     jump.postMessage(JSON.stringify(data));
      //   }, 1000)
      // })



      setTimeout(() => {
        let data = {
          jump:'index'
        }
        jump.postMessage(JSON.stringify(data));
      },1000)
    }
  }
</script>

<style scoped>
  #main{
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
  }
  img{
    display: block;
    width: 20vw;
    margin: 0 auto;
  }
  p{
    font-size: 6.5vw;
    margin-top: 5vw;
  }
</style>
